<div class="pax-container">
  <ng-container *ngIf="!hasDefaultPax; else paxSaved">
    <app-new-pax
      [type]="travelerType"
      [isError]="sectionError"
      [travelerInfoType]="travelerInfoType"
      [ordinalKey]="ordinalKey"
      [moreThanOneUser]="moreThanOneUser"
      (addPax)="toggleForm()"
      (openList)="toggleList()"
      [listUILength]="listUILength"
      [travelerBookingProvider]="travelerBookingProvider"
      [isHome]="true"
      [travelerAge]="travelerAge">
    </app-new-pax>
  </ng-container>
</div>

<ng-template #paxSaved>
  <div class="paxSection__edit" *ngIf="showEditContainer">
    <div class="paxSection__edit--icon">
      <app-ds-icon
        [icon]="icons.EditOutline"
        [size]="14">
      </app-ds-icon>
    </div>
    <app-ds-typography
      [size]="typographyFontSize.XXXS"
      [tag]="'p'"
      [color]="typographyColor.Secondary"
      [text]="'BOOKING_MODULE.PAX.PROFILE_CHANGE' | transloco">
    </app-ds-typography>
    <div class="paxSection__edit--action">
      <app-ds-typography
        [size]="typographyFontSize.XXXS"
        [tag]="'p'"
        [color]="typographyColor.Highlight"
        [textDecoration]="'underline'"
        [text]="'BOOKING_MODULE.PAX.CHANGE' | transloco"
        (click)="toggleList()">
      </app-ds-typography>
    </div>
  </div>
  <ng-container>
    <app-pax-data-resumed
      [type]="travelerType"
      [paxError]="travelerError"
      [paxSectionErrors]="paxSectionErrors"
      [travelerInfoType]="travelerInfoType"
      [isAnInternationalTrip]="isAnInternationalTrip"
      [showFrequentFlyer]="showFrequentFlyer"
      [paxData]="defaultData"
      [programs]="frequentFlyerPrograms"
      [defaultAirlineProgram]="defaultAirline | frequentFlyerName | async"
      [bookingSource]="bookingSource"
      [disabledDocumentInputs]="disabledDocumentInputs"
      [travelerBookingProvider]="travelerBookingProvider"
      (openList)="toggleList()"
      (openListPrograms)="toggleFrequentPassengerList()"
      (openMarriottProgram)="toggleMarriottProgramForm()"
      (openFrequenPassengerForm)="openLoyaltyByResumed($event)"
      (openPassportForm)="togglePassportForm()">
    </app-pax-data-resumed>
  </ng-container>
</ng-template>

<ng-container *ngIf="isMobile; else desktopPaxListModal">
  <app-swipe-up
    [height]="95"
    [showSwipeUp]="showList"
    [showHeader]="true"
    [showFooter]="true"
    [title]="'BOOKING_MODULE.PAX.SAVED_PAX' | transloco: { travelers: paxTypeTranslate }"
    [subTitle]="'BOOKING_MODULE.PAX.SAVED_PAX_DESCRIPTION' | transloco"
    (toggleShowSwipeUp)="toggleList()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="travelersList"></ng-container>
    </ng-container>
    <ng-container footer>
      <ng-container *ngTemplateOutlet="travelersListFooter"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #desktopPaxListModal>
  <ng-container *ngIf="showTravelersListModal">
    <app-modal
      [width]="640"
      [showHeader]="true"
      [manipulateDOM]="true"
      (toggleModal)="toggleList()"
      [title]="'BOOKING_MODULE.PAX.SAVED_PAX' | transloco: { travelers: paxTypeTranslate }"
      [subTitle]="'BOOKING_MODULE.PAX.SAVED_PAX_DESCRIPTION' | transloco">
      <ng-container content>
        <ng-container *ngTemplateOutlet="travelersList"></ng-container>
        <ng-container *ngTemplateOutlet="travelersListFooter"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-template>

<ng-container *ngTemplateOutlet="travelerForm"></ng-container>

 <ng-container *ngIf="isMobile; else desktopLoyaltyFormModal">
  <app-swipe-up
    [height]="95"
    [classType]="'booking-swipe'"
    [showSwipeUp]="showFrequentPassengerForm"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.PAX.LOYALTY.LOYALTY_FORM_TITLE' | transloco"
    [subTitle]="'BOOKING_MODULE.PAX.LOYALTY.LOYALTY_FORM_DESCRIPTION' | transloco"
    (toggleShowSwipeUp)="closeLoyalty()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="loyaltyForm"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #desktopLoyaltyFormModal>
  <ng-container *ngIf="showFrequentPassengerFormModal">
    <app-modal
      [showHeader]="true"
      [title]="'BOOKING_MODULE.PAX.LOYALTY.LOYALTY_FORM_TITLE' | transloco"
      [subTitle]="'BOOKING_MODULE.PAX.LOYALTY.LOYALTY_FORM_DESCRIPTION' | transloco"
      [width]="640"
      [manipulateDOM]="false"
      (toggleModal)=closeLoyalty()>
      <ng-container content>
        <ng-container *ngTemplateOutlet="loyaltyForm"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-template>

<ng-container *ngIf="isMobile; else desktopLoyaltyListModal">
  <app-swipe-up
    [height]="95"
    [showSwipeUp]="showFrequentPassengerList"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.PAX.LOYALTY.LOYALTY_TITLE' | transloco"
    [subTitle]="'BOOKING_MODULE.PAX.LOYALTY.LOYALTY_LIST_DESCRIPTION' | transloco"
    (toggleShowSwipeUp)="toggleFrequentPassengerList()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="loyaltyFormList"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #desktopLoyaltyListModal>
  <ng-container *ngIf="showFrequentPassengerListModal">
    <app-modal
      [width]="640"
      [manipulateDOM]="false"
      [showHeader]="true"
      [title]="'BOOKING_MODULE.PAX.LOYALTY.LOYALTY_TITLE' | transloco"
      [subTitle]="'BOOKING_MODULE.PAX.LOYALTY.LOYALTY_LIST_DESCRIPTION' | transloco"
      (toggleModal)="toggleFrequentPassengerList()">
      <ng-container content>
        <ng-container *ngTemplateOutlet="loyaltyFormList"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-template>

<ng-container *ngIf="isMobile; else desktopPassportFormModal">
  <app-swipe-up
    [height]="95"
    [showSwipeUp]="showPassportForm"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.PAX.PASSPORT.TITLE' | transloco"
    [subTitle]="'BOOKING_MODULE.PAX.PASSPORT.DESCRIPTION' | transloco"
    (toggleShowSwipeUp)="togglePassportForm()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="passportForm"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #desktopPassportFormModal>
  <ng-container *ngIf="showPassportFormModal">
    <app-modal
      [width]="640"
      [manipulateDOM]="false"    
      [showHeader]="true"
      [title]="'BOOKING_MODULE.PAX.PASSPORT.TITLE' | transloco"
      [subTitle]="'BOOKING_MODULE.PAX.PASSPORT.DESCRIPTION' | transloco"
      (toggleModal)="togglePassportForm()">
      <ng-container content>
        <ng-container *ngTemplateOutlet="passportForm"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-template>

<ng-container *ngIf="showMarriottRelatedContent">
  <ng-container *ngIf="isMobile; else desktopMarriottProgramFormModal">
    <app-swipe-up
    [height]="95"
    [showSwipeUp]="showMarriottProgramForm"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.MARRIOTT_BONVOY.FORM_TITLE' | transloco"
    (toggleShowSwipeUp)="toggleMarriottProgramForm()">
    <ng-container content>
      <ng-container *ngTemplateOutlet="marriottForm"></ng-container>
    </ng-container>
  </app-swipe-up>
  </ng-container>

  <ng-template #desktopMarriottProgramFormModal>
    <app-modal
    [width]="820"
    [manipulateDOM]="false"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.MARRIOTT_BONVOY.FORM_TITLE' | transloco"
    (toggleModal)="toggleMarriottProgramForm()">
      <ng-container content>
        <ng-container *ngTemplateOutlet="marriottForm"></ng-container>
      </ng-container>
    </app-modal>
  </ng-template>

  <ng-container *ngIf="isMobile; else desktopCreateMarriottProgramFormModal">
    <app-swipe-up
    [height]="95"
    [showSwipeUp]="showMarriottProgramCreateForm"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.MARRIOTT_BONVOY.CREATE_FORM_TITLE' | transloco"
    (toggleShowSwipeUp)="toggleMarriottProgramCreateForm()">
      <ng-container content>
        <ng-container *ngTemplateOutlet="marriottCreateForm"></ng-container>
      </ng-container>
    </app-swipe-up>
  </ng-container>

  <ng-template #desktopCreateMarriottProgramFormModal>
    <app-modal
    *ngIf="showMarriottProgramCreateForm"
    [width]="820"
    [manipulateDOM]="false"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.MARRIOTT_BONVOY.CREATE_FORM_TITLE' | transloco"
    (toggleModal)="toggleMarriottProgramCreateForm()">
      <ng-container content>
        <ng-container *ngTemplateOutlet="marriottCreateForm"></ng-container>
      </ng-container>
    </app-modal>
  </ng-template>

  <ng-template #marriottForm>
    <app-marriott-bonvoy-form
      [form]="travelerDynamicForm"
      [defaultValue]="defaultData?.bonvoy_number || marriottloyaltyNumber?.loyalty_id"
      [defaultPaxFullName]="defaultPaxFullName"
      [suggestedValue]="marriottloyaltyNumber?.loyalty_id"
      [isMobile]="isMobile"
      [isLoadingPaxForm]="isLoadingPaxForm"
      (updateMarriottBonvoyNumber)="updateMarriottBonvoyNumber($event)"
      (createMarriottBonvoyNumber)="toggleMarriottProgramCreateForm()">
    </app-marriott-bonvoy-form>
  </ng-template>

  <ng-template #marriottCreateForm>
    <app-marriott-bonvoy-create-form
      [defaultEmailValue]="user?.email"
      [marriottCreatedAccount]="marriottCreatedAccount"
      [isLoadingMarriottCreateForm]="isLoadingMarriottCreateForm"
      [marriottCreateAccountShowStatus]="marriottCreateAccountShowStatus"
      (createMarriottBonvoyAccount)="mapMarriottBonvoyAccount($event)"
      (updateMarriottBonvoyNumber)="updateMarriottBonvoyNumber($event)"
      (resetMarriottCreateAccountShowStatus)="resetMarriottCreateAccountShowStatus.emit()">
    </app-marriott-bonvoy-create-form>
  </ng-template>
  
</ng-container>

<ng-template #travelersList>
  <div class="content-container">
    <div class="body list-cont">
      <ng-container *ngFor="let traveler of paxTravelers; index as i; last as isLast">
        <app-each-item
          [type]="travelerType"
          [isPassenger]="true"
          [traveler]="traveler"
          [totalItems]="paxTravelers.length"
          [isLast]="isLast"
          [productCode]="productCode"
          (edit)="editPax($event)"
          (remove)="removePaxEvent($event)"
          (selectTraveler)="selectPaxEvent($event)">
        </app-each-item>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #travelersListFooter>
  <div class="content-container">
    <div class="fixed-body">
      <app-new-pax
        [label]="'BOOKING_MODULE.PAX.ADD_PERSON' | transloco: { type: travelerLabel | transloco } | capitalize"
        [icon]="icons.PersonOutline"
        [isHome]="false"
        (swipeClick)="doubleToggle()">
      </app-new-pax>
    </div>
  </div>
</ng-template>

<ng-template #travelerForm>
  <app-traveler-information
    [form]="form"
    [user]="user"
    [countries]="countries"
    [frequentFlyerPrograms]="frequentFlyerPrograms"
    [travelerInfoType]="travelerInfoType"
    [paxTraveler]="paxTraveler"
    [travelers]="paxTravelers"
    [showFrequentFlyer]="showFrequentFlyer"
    [isAnInternationalTrip]="isAnInternationalTrip"
    [travelerAge]="travelerAge"
    [travelerType]="travelerType"
    [isSubmittedSuccess]="isSubmittedSuccess"
    [travelerBookingProvider]="travelerBookingProvider"
    [isSubmitted]="isSubmitted"
    [validator]="validator"
    [travelerNumber]="travelerNumber"
    [ordinalNumber]="ordinalNumber"
    [businessRules]="businessRules"
    [productCode]="productCode"
    [productProvider]="productProvider"
    [bookingSource]="bookingSource"
    [isLoadingPaxForm]="isLoadingPaxForm"
    [isMobile]="isMobile"
    [showForm]="showForm"
    [paxTravelerHasBeenSelected]="paxTravelerHasBeenSelected"
    (closeForm)="closeForm()"
    (create)="createTravelerPax($event)"
    (update)="updateTravelerPax($event)"
    (selected)="travelerHasSuccessfullyChanged()">
  </app-traveler-information>
</ng-template>

<ng-template #loyaltyForm>
  <div class="content-container">
    <div class="body" *ngIf="showDeviceLoyaltyForm">
      <app-loyalty-form
        [selectedLoyalty]="paxLoyalty"
        [form]="travelerDynamicForm"
        [defaultAirline]="defaultAirline"
        [programs]="frequentFlyerPrograms"
        [isMobile]="isMobile"
        (update)="updateLoyaltyEvent($event)"
        (create)="createLoyaltyEvent($event)">
      </app-loyalty-form>
    </div>
  </div>
</ng-template>

<ng-template #loyaltyFormList>
  <div class="content-container">
    <div class="body list-cont loyalty" *ngIf="!!paxTraveler">
      <ng-container *ngFor="let loyalty of paxTraveler.loyalty; index as i; last as isLast">
        <app-each-loyalty
          *ngIf="!!paxTraveler.loyalty"
          [loyalty]="loyalty"
          [isLast]="isLast"
          [totalItems]="paxTraveler.loyalty.length"
          (edit)="editLoyaltyEvent($event)"
          (remove)="removeLoyaltyEvent($event)"
          (selectLoyalty)="selectLoyaltyEvent($event)">
        </app-each-loyalty>
      </ng-container>
    </div>
    <div class="fixed-body">
      <app-new-pax
        [label]="'BOOKING_MODULE.PAX.NEW_FREQUENT_FLYER_PROGRAM' | transloco"
        [icon]="icons.Points"
        [isHome]="false"
        (swipeClick)="doubleToggleLoyalty()">
      </app-new-pax>
    </div>
  </div>
</ng-template>

<ng-template #passportForm>
  <div class="content-container">
    <div class="body" *ngIf="showDevicePassportForm">
      <app-passport-form
        [form]="travelerDynamicForm"
        [type]="travelerType"
        (setDocumentToPassport)="updateTravelerDocumentPassport()">
      </app-passport-form>
    </div>
  </div>
</ng-template>
